/* eslint-disable react-hooks/exhaustive-deps */
import { find, map } from "lodash";

type Params = {
  domain?: string;
  exemple?: string;
  theme?: string;
};

const getOrientation = (data: Domain[], params: Params) => {
  const domainData: Domain | undefined = find(
    data,
    (data) => data.domain === params.domain
  );

  let description;
  let orientation;
  let contacts;
  let preProcedure;

  map(domainData?.situations, (situation) => {
    if (params.domain !== "alerte") {
      if (params.domain === "autre") {
        if (situation.title.toLowerCase() === params.exemple?.toLowerCase()) {
          description = situation.description;
          orientation = situation.orientation;
          contacts = situation.contacts;
        }
      } else {
        map(situation.exemples, (exemple) => {
          if (exemple.title.toLowerCase() === params.exemple?.toLowerCase()) {
            description = exemple.description;
            orientation = exemple.orientation;
            contacts = exemple.contacts;
            preProcedure = exemple.preProcedure;
          }
        });
      }
    } else {
      if (situation.title.toLowerCase() === params.theme?.toLowerCase()) {
        if (situation.title.toLowerCase() === "Je souhaite lancer une alerte") {
          description = "Je souhaite lancer une alerte";
        } else {
          description = situation.description;
          orientation = situation.orientation;
          contacts = situation.contacts;
        }
      }
    }
  });

  return {
    domainData,
    description,
    orientation,
    contacts,
    preProcedure,
  };
};

export default getOrientation;
